import { all } from 'redux-saga/effects'
import approvalRequestsWatcher from '../routes/my-requests-my-approvals/myApprovalsRequests-saga'
import getSystemAnnouncementWatcher from '../components/app_chrome/header/announcement/saga'

export default function*() {
  yield all([...approvalRequestsWatcher, getSystemAnnouncementWatcher])
}
